TransferToTemplateDialogController.$inject = [
    '$scope',
    '$modalInstance',
    'internalTransfersService',
];

export default function TransferToTemplateDialogController(
    $scope,
    $modalInstance,
    internalTransfersService
) {
    $scope.cancel = cancel;
    $scope.create = create;
    $scope.setForm = setForm;
    $scope.template = { name: null };
    $scope.disableCreate = disableCreate;

    function cancel() {
        $modalInstance.dismiss();
    }

    function create() {
        internalTransfersService.validateTemplateName($scope.template.name).then(response => {
            if (response.isValid) {
                $scope.form.transferTemplateNameDialog.$setValidity('unique', true);
                $modalInstance.close($scope.template.name);
            } else {
                $scope.form.transferTemplateNameDialog.$setValidity('unique', false);
            }
        });
    }

    function disableCreate() {
        return $scope.form.transferTemplateNameDialog.$error.required;
    }

    function setForm(form) {
        $scope.form = form;
    }
}
